export enum RegistrationType {
    Signup = 'signup',
    Subscribe = 'subscribe',
}
